module.exports = __webpack_public_path__ + "static/media/last_page.e7197ea6.jpg";